export default __webpack_public_path__ + "static/media/480_business05-it-web.37ea091e.png";